export default function holdCursorPosition(e) {
    const input = e.target;
    const cursorPosition = input.selectionStart;
    window.requestAnimationFrame(() => {
        input.selectionStart = cursorPosition;
        input.selectionEnd = cursorPosition;
    });
}
